<script>
export default {
    name: "DispenseModal",

    data() {

        return {
            active: 0,
            activeClass: `bg-gray-100 border-l-2 border-r-2 border-t-2 border-gray-500 rounded-t-md z-10 -mb-1`,
            inActiveClass: `bg-gray-300 border-l border-r border-t`,
        };
    },

    props: {
        showModal: Boolean,
        patient: {
            type: Object,
        },
        visit: {
          type: Object,
          default: () => ({}),
        },
        admission: {
          type: Object,
          default: () => ({}),
        },
        outpatient: Boolean,
    },

    components: {
      "non-pharmaceuticals-tab": () => import('./tabs/NonPharmaceuticals.vue'),
      "pharmaceuticals-tab": () => import('./tabs/Pharmaceuticals.vue'),
      "dailyorders-tab": () => import('./tabs/DailyOrders.vue')
    },
}
</script>
<template>
<tail-modal :show="showModal" dimension="md:w-11/12 w-full">
  <template v-slot:title>
    <h5 class="font-medium text-sm">Dispense</h5>
  </template>
  <template v-slot:modal-body>
    <div class="w-full flex flex-wrap content-start gap-1">
        <div
            class="md:w-1/2 w-full flex flex-wrap content-start border-2 
              border-blue-700 overflow-auto"
          >
            <div class="w-full p-tiny bg-blue-700">
              <h5 class="font-medium text-white text-sm">Patient Details</h5>
            </div>
            <div class="md:w-1/2 w-full p-tiny">
              <h5 class="font-medium text-sm">Name: {{ patient.names }}</h5>
            </div>
            <div class="md:w-1/4 w-1/2 p-tiny">
              <h5 class="font-medium text-sm">IP File No: {{ patient.ipfileno || `-` }}</h5>
            </div>
            <div class="md:w-1/4 w-1/2 p-tiny">
              <h5 class="font-medium text-sm">OP File No: {{ patient.opfileno || `-` }}</h5>
            </div>
            <div class="md:w-1/4 w-1/2 p-tiny">
              <h5 class="font-medium text-sm">Gender: {{ patient.gender }}</h5>
            </div>
            <div class="md:w-1/4 w-1/2 p-tiny">
              <h5 class="font-medium text-sm">
                DOB: {{ patient.dob | dateFormat }}
              </h5>
            </div>
            <div class="md:w-1/4 w-1/2 p-tiny">
              <h5 class="font-medium text-sm">MRN: {{ patient.patienT_ID }}</h5>
            </div>
            <div class="md:w-1/4 w-1/2 p-tiny">
              <h5 class="font-medium text-sm">
                Visit No: {{ patient.visitNo }}
              </h5>
            </div>
        </div>
        <div v-if="outpatient" class="flex-1 w-full border-2 border-blue-700">
              <div class="w-full p-1 bg-blue-700 text-xs font-medium text-white">
                  Clinic Details
              </div>
              <div class="w-full p-1">
                  <h5 class="font-medium text-sm">Clinic: {{ visit.clinic }}</h5>
                  <h5 class="font-medium text-sm">Doctor: {{ visit.doctor || `-` }}</h5>
              </div>
        </div>
        <div v-if="!outpatient" class="flex-1 w-full border-2 border-blue-700">
              <div class="w-full p-1 bg-blue-700 text-xs font-medium text-white">
                  Ward Details
              </div>
              <div class="w-full p-1">
                  <h5 class="font-medium text-sm">Package: {{ admission.type }}</h5>
                  <h5 class="font-medium text-sm">Ward: {{ admission.ward }}</h5>
                  <h5 class="font-medium text-sm">Bed: {{ admission.bed }}</h5>
              </div>
        </div>
        <div class="flex-1 w-full border-2 border-indigo-400">
              <div class="w-full p-1 bg-indigo-400 text-xs font-medium text-white">
                  Payment Details
              </div>
              <div class="w-full p-1">
                  <p class="font-medium text-xs">
                    {{ outpatient ? visit.pMode : admission.pMode }}
                  </p>
              </div>
        </div>
    </div>
    <div class="w-full flex flex-wrap mt-3">
        <ul class="w-full flex border-b-2 mb-2">
            <li class="-mb-px mr-1">
              <a @click.prevent="active = 0" 
                class="btn-sm text-sm text-gray-900 rounded-t-md inline-block 
                  px-4 font-bold whitespace-no-wrap" 
                :class="active== 0 ?  activeClass : inActiveClass" 
                href="javascript:void(0)">Pharmaceuticals</a>
            </li>
            <li class="-mb-px mr-1">
              <a @click.prevent="active = 1" 
                class="btn-sm text-sm text-gray-900 rounded-t-md inline-block 
                  px-4 font-bold whitespace-no-wrap" 
                :class="active == 1 ? activeClass : inActiveClass" 
                href="javascript:void(0)">Non-Pharmaceuticals</a>
            </li>
            <li class="-mb-px mr-1">
              <a @click.prevent="active = 2" 
                class="btn-sm text-sm text-gray-900 rounded-t-md inline-block 
                  px-4 font-bold whitespace-no-wrap" 
                :class="active == 2 ? activeClass : inActiveClass" 
                href="javascript:void(0)">Orders</a>
            </li>
        </ul>
        <pharmaceuticals-tab 
          :patient="patient"
          v-if="active == 0" 
        />
        <non-pharmaceuticals-tab 
          v-if="active == 1" 
        />
        <dailyorders-tab  :patient="patient" v-if="active==2"></dailyorders-tab>
    </div>
  </template>
  <template v-slot:modal-footer>
    <button class="btn-danger btn-sm text-xs rounded" 
        @click.prevent="$emit(`closeModal`)">Close</button>
  </template>
</tail-modal>
</template>
